import { Dir } from '../../interface'
import { Search } from '../search'
import { Wrapper } from './atoms'

interface Props {
  dirs: Dir[]
}

export const SearchBanner = ({ dirs }: Props) => {
  return (
    <Wrapper>
      <Search dirs={dirs} />
    </Wrapper>
  )
}
